var heading_default = {
  "fontElementMap": "_5vmXZ",
  "elementSpacing": "_8w186",
  "headerOne": "a5no- _8w186",
  "headerTwo": "t3F90 _8w186",
  "headerThree": "vZdyw _8w186",
  "headerFour": "cmD08 _8w186",
  "headerFive": "MQSLg _8w186",
  "headerSix": "pGHhu _8w186",
  "child": "_9tKUz"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
